import { Component, Input, OnInit } from '@angular/core';
import { UserRest } from '../../core/services/core.user.rest.service';
import { MenuService } from '../mega-menu/mega-menu.service.component';

import * as _ from 'lodash';

@Component({
    selector: 'user-project-list',
    template: require('./user.project-list.component.html')
})
export class UserProjectListComponent implements OnInit {

    @Input() user: any = null;

    projects:any = false;
    filterText: string = '';
    sortField: string = 'projectName';
    miniLoading: boolean = false;
    miniMenuProject: any = false;
    setFilterText: any = null;

    constructor(private userRest: UserRest, private menuService: MenuService) { }
    
    ngOnInit() {
        this.setFilterText = _.debounce(this.fetchProjects, 400);
        this.fetchProjects();
    }    

    setSort(fieldName?: string) {
        var newField = (fieldName == 'activity') ? 'activity' : 'projectName';
        if (newField != this.sortField) {
            this.sortField = newField;
            this.fetchProjects();
        }
    }

    showProjectMiniMenu(unixName) {

        // Toggle display if currently shown
        if (_.get(this, 'miniMenuProject.unixName', '') == unixName) {
            this.miniMenuProject = false;
            return false;
        }

        this.miniLoading = unixName;

        this.menuService.getProjectMenu(unixName).then(
            (pm) => this.miniMenuProject = pm,
            (response) => console.log(response)
        ).finally(
            () => this.miniLoading = false
        );
    }

    fetchProjects() {
        this.miniLoading = false;
        this.miniMenuProject = false;
        this.projects = false;

        this.userRest.getProjects(this.user.unixName,
        {
            q: this.filterText,
            sort_field: this.sortField,
            max: 20
        }).then(
            (response) => {
                this.projects = _.get(response, 'items', []);
            }, (response) => {
                console.log(response);
                this.projects = [];
            }
        );
    }

    trackById(index: number, item: any): any {
        return item.id;
    }
}
